import {GearIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'
import {DiffWhitespaceToggle} from './DiffWhitespaceToggle'
import {DiffViewPreferenceToggle} from './DiffViewPreferenceToggle'

export function DiffViewSettings() {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton aria-label="Diff view settings" icon={GearIcon} sx={{ml: 2}} variant="invisible" />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList>
          <DiffViewPreferenceToggle />
          <ActionList.Divider />
          <DiffWhitespaceToggle />
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ DiffViewSettings.displayName ||= 'DiffViewSettings' } catch {}